import { render } from "./AccountDetailsPanel.vue?vue&type=template&id=5761d27a&scoped=true&lang=pug"
import script from "./AccountDetailsPanel.vue?vue&type=script&lang=js"
export * from "./AccountDetailsPanel.vue?vue&type=script&lang=js"

import "./AccountDetailsPanel.vue?vue&type=style&index=0&id=5761d27a&scoped=true&lang=scss"

import exportComponent from "/builds/wiwdata/applications/finance-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5761d27a"]])

export default __exports__